import { Theme } from '@mui/material/styles';

export const dataContractDefinitionWidgetStyles = {
  container: (theme: Theme) => ({
    width: '100%',
    height: '100vh',
    border: 'none',
    position: 'relative',
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'var(--xlrt-color-ui-gray10)'
        : 'var(--xlrt-color-ui-white)',
  }),
  loadingOverlay: (theme: Theme) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(24, 24, 24, 0.7)' // var(--xlrt-color-ui-gray10) with 90% opacity
        : 'rgba(255, 255, 255, 0.7)', // var(--xlrt-color-ui-white) with 90% opacity
    zIndex: 10,
  }),
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
  },
  spinner: {
    color: 'var(--xlrt-color-ui-white)',
  },
};
